import type { InfoHintDetail } from '@cou/admin-ui';
import { formatDateTime } from './format-date';
import type { AdminContestWithEntryCount } from './contests-client';

/**
 * The rows behind a Contest name's ⓘ hint.
 *
 * Lives here rather than in `@cou/admin-ui` because that package is game-agnostic — it knows about
 * label/value rows, never about Contests. The id leads: it is the thing an operator cannot read off
 * the screen and the reason they opened the hint at all.
 */
export function contestDetails(contest: AdminContestWithEntryCount): InfoHintDetail[] {
  return [
    { label: 'Contest ID', value: contest.id, copyable: true },
    { label: 'State', value: contest.state },
    { label: 'Opens', value: formatDateTime(contest.opensAt) },
    { label: 'Closes', value: formatDateTime(contest.closesAt) },
    { label: 'Campaign', value: contest.campaignId, copyable: true },
    { label: 'Round', value: contest.round, copyable: true },
  ];
}
